import React from 'react';
import { EventsEventsFormUpdate } from 'src/features/user/expert/Events-events/EventsEventsContainer';

export const EditEvents: React.FC = () => {
  return <EventsEventsFormUpdate />;
};
